import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { ShieldCheck, ShieldAlert, PenLine, Upload, Trash2 } from "lucide-react";
import { api, errMsg, fmtDate } from "@/lib/api";
import { useAuth } from "@/lib/auth";

const ORIGEN = { tablet: "Firmado en la tablet", pdf: "PDF subido", web: "PDF de la web" };

export const ProteccionDatosPaciente = ({ patientId }) => {
  const [list, setList] = useState([]);
  const [webOk, setWebOk] = useState(false);
  const file = useRef(null);
  const isAdmin = useAuth().user?.role === "admin";
  const load = () => api.get(`/patients/${patientId}/consentimientos`).then((r) => setList(r.data));
  useEffect(() => {
    load();
    api.get(`/patients/${patientId}/cuestionarios`).then((r) => setWebOk(r.data.some((c) => c.proteccion?.acepta)));
  }, [patientId]); // eslint-disable-line react-hooks/exhaustive-deps
  const subir = async (e) => {
    const f = e.target.files[0];
    e.target.value = "";
    if (!f) return;
    if (f.type !== "application/pdf" || f.size < 200) return toast.error("El archivo no es un PDF");
    if (f.size > 5_500_000) return toast.error("El PDF es demasiado grande (máximo 5 MB)");
    const b64 = await new Promise((res) => { const r = new FileReader(); r.onload = () => res(r.result.split(",")[1]); r.readAsDataURL(f); });
    try {
      await api.post(`/patients/${patientId}/consentimientos/pdf`, { pdf_base64: b64, filename: f.name });
      toast.success("Consentimiento subido");
      load();
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  const borrar = async (id) => {
    if (!window.confirm("¿Borrar este consentimiento?")) return;
    await api.delete(`/consentimientos/${id}`);
    load();
  };
  const ok = list.length > 0 || webOk;
  return (
    <div className="bg-white border border-slate-200 rounded-lg p-4" data-testid="proteccion-datos-paciente">
      <div className={`flex items-center gap-2 text-sm font-semibold ${ok ? "text-emerald-700" : "text-rose-700"}`} data-testid="proteccion-estado">
        {ok ? <ShieldCheck className="h-4 w-4" /> : <ShieldAlert className="h-4 w-4" />}{ok ? "Protección de datos firmada" : "Falta la protección de datos"}
      </div>
      {webOk && !list.length && <div className="mt-1 text-[11px] text-slate-500">Aceptada en el cuestionario de la web.</div>}
      <div className="mt-2 divide-y divide-slate-100">
        {list.map((c) => (
          <div key={c.id} className="flex items-center gap-2 py-1.5 text-xs" data-testid={`consent-${c.id}`}>
            <Link to={`/consentimientos/${c.id}`} target="_blank" className="flex-1 text-[#1E3A8A] hover:underline">{ORIGEN[c.origen]} · {fmtDate(c.fecha)}{c.respuestas?.firmante_nombre ? ` · ${c.respuestas.firmante_nombre}` : ""}</Link>
            {isAdmin && <button onClick={() => borrar(c.id)} title="Borrar" data-testid={`consent-del-${c.id}`} className="text-slate-400 hover:text-rose-600"><Trash2 className="h-3.5 w-3.5" /></button>}
          </div>
        ))}
      </div>
      <div className="mt-2 flex flex-wrap gap-2">
        <Link to={`/pacientes/${patientId}/firmar`} data-testid="firmar-tablet-btn" className="inline-flex items-center gap-1 rounded-md bg-[#1E3A8A] px-3 py-1.5 text-xs text-white"><PenLine className="h-3.5 w-3.5" />Firmar en tablet</Link>
        <button onClick={() => file.current.click()} data-testid="subir-consent-btn" className="inline-flex items-center gap-1 rounded-md border border-slate-300 px-3 py-1.5 text-xs text-slate-700"><Upload className="h-3.5 w-3.5" />Subir PDF firmado</button>
        <input ref={file} type="file" accept="application/pdf" className="hidden" onChange={subir} data-testid="subir-consent-input" />
      </div>
    </div>
  );
};
